import './style.scss';
import React, { Component } from 'react';

export class Video extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { onVideoMount } = this.props;
    onVideoMount && onVideoMount();
  }

  render() {
    const { src, ref, style = {}, videoRef } = this.props;
    return (
      <div className={'video-container'} ref={ref} style={style}>
        <video src={src} ref={videoRef} playsInline={true} />
      </div>
    );
  }
}
